import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const removeEventCategory = async ({
  orgId,
  eventCategoryId,
}: {
  orgId: string;
  eventCategoryId: string;
}): Promise<void> => {
  const response = await axiosClient.delete(
    `/${orgId}/event-categories/${eventCategoryId}`,
  );
  return response.data;
};

export function useRemoveEventCategory(
  queryOptions?: UseMutationOptions<
    void,
    HttpError,
    { orgId: string; eventCategoryId: string }
  >,
) {
  return useMutation({
    mutationFn: ({ orgId, eventCategoryId }) =>
      removeEventCategory({ orgId, eventCategoryId }),
    ...queryOptions,
  });
}
